import { Link } from "react-router-dom";
import { Mail, MapPin, Leaf, Phone, Headphones, ShoppingBag } from "lucide-react";
import Logo from "@/components/layout/Logo";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0B132B] text-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-20">
        <div className="grid lg:grid-cols-4 gap-12">
          <div>
            <div className="mb-5">
              <Logo size={44} dark />
            </div>
            <p className="text-sm text-white/60 leading-relaxed max-w-xs">
              Helping New Zealand households move to smarter, cleaner home energy — starting with hot water.
            </p>
            <div className="mt-6 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-xs text-white/80">
              <Leaf className="h-3.5 w-3.5 text-[#10B981]" /> NZ home electrification
            </div>
          </div>

          <div>
            <p className="text-xs uppercase tracking-widest text-white/40 mb-4">Products</p>
            <ul className="space-y-3 text-sm">
              <li><Link to="/hot-water-heat-pumps" className="text-white/80 hover:text-white">Hot Water Heat Pumps</Link></li>
              <li><Link to="/neopower-black-shield" className="text-white/80 hover:text-white">NeoPower Black Shield</Link></li>
              <li><Link to="/aeromax-270l" className="text-white/80 hover:text-white">AeroMax 270L (Soon)</Link></li>
              <li><Link to="/solar-battery" className="text-white/80 hover:text-white">Solar + Battery (Next)</Link></li>
            </ul>
          </div>

          <div>
            <p className="text-xs uppercase tracking-widest text-white/40 mb-4">Get started</p>
            <ul className="space-y-3 text-sm">
              <li><Link to="/savings-calculator" data-testid="footer-link-calculator" className="text-white/80 hover:text-white">Savings Calculator</Link></li>
              <li><Link to="/installation" data-testid="footer-link-installation" className="text-white/80 hover:text-white">Installation</Link></li>
              <li><Link to="/free-home-assessment" data-testid="footer-link-free-assessment" className="text-white/80 hover:text-white">Free Home Assessment</Link></li>
              <li><Link to="/nz-green-loan-guide" data-testid="footer-link-green-loan" className="text-white/80 hover:text-white">NZ Green Loan Guide</Link></li>
              <li><Link to="/home-shows" data-testid="footer-link-home-shows" className="text-white/80 hover:text-white">Home Shows</Link></li>
              <li><Link to="/faqs" data-testid="footer-link-faq" className="text-white/80 hover:text-white">FAQs</Link></li>
            </ul>
          </div>

          <div>
            <p className="text-xs uppercase tracking-widest text-white/40 mb-4">Contact us</p>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2.5 text-white/80" data-testid="footer-contact-support">
                <Headphones className="h-4 w-4 mt-0.5 text-[#10B981] shrink-0" />
                <div>
                  <p className="text-[10px] uppercase tracking-widest text-white/40 font-semibold">Support</p>
                  <a href="mailto:support@aeromaxenergy.co.nz" className="hover:text-white">support@aeromaxenergy.co.nz</a>
                </div>
              </li>
              <li className="flex items-start gap-2.5 text-white/80" data-testid="footer-contact-sales">
                <ShoppingBag className="h-4 w-4 mt-0.5 text-[#10B981] shrink-0" />
                <div>
                  <p className="text-[10px] uppercase tracking-widest text-white/40 font-semibold">Sales</p>
                  <a href="mailto:sales@aeromaxenergy.co.nz" className="hover:text-white">sales@aeromaxenergy.co.nz</a>
                </div>
              </li>
              <li className="flex items-start gap-2.5 text-white/80" data-testid="footer-contact-phone">
                <Phone className="h-4 w-4 mt-0.5 text-[#10B981] shrink-0" />
                <div>
                  <p className="text-[10px] uppercase tracking-widest text-white/40 font-semibold">Phone</p>
                  <a href="tel:05082376629" className="hover:text-white tracking-tight font-semibold">0508 AEROMAX</a>
                </div>
              </li>
              <li className="flex items-start gap-2.5 text-white/60 pt-1">
                <MapPin className="h-4 w-4 mt-0.5 text-[#10B981] shrink-0" />
                Servicing homes across New Zealand
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 text-xs text-white/40 grid md:grid-cols-2 gap-4">
          <p>© {new Date().getFullYear()} AeroMax Energy. All rights reserved.</p>
          <p className="md:text-right">
            Estimates only. Actual results vary. Pricing subject to site assessment.
          </p>
        </div>
      </div>
    </footer>
  );
}
